import { getCollectionFields } from '../pluginComponentApi';
import { FieldTypes, ImageUrlFields } from 'drapcode-constant';
import { fieldTraitProgressBarOptions, fieldTraitTextContentOptions } from '../dataGroup/traitsApi';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const { pfx, pfxFile, projectId, collections, pageCollection } = opts;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType('child-data-group', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: true,
          icon: '<i class="wb webconnect-list-task"></i>',
          'custom-name': opts.labelTable,
          projectId: projectId,
          traits: [
            ...domc.getType('table').model.prototype.defaults.traits,
            {
              type: 'select',
              label: 'Reference Field',
              name: 'multiReferenceField',
              changeProp: 1,
              options: [],
            },
          ],
        },

        init() {
          const collection = this.findCollectionFromDataGroup();
          this.set('parentSelectedCollection', collection);
          this.handleParentCollectionChange();
          this.handleCollectionNameChange();
          this.on('change:parentSelectedCollection', this.handleParentCollectionChange);
          this.on('change:multiReferenceField', this.handleCollectionNameChange);
        },
        findCollectionFromDataGroup() {
          const dataGroup = this.closestType('data-group');
          if (dataGroup) {
            return dataGroup.get('selectedCollectionData') || {};
          }
        },

        findCustomType(type) {
          const result = [];
          const find = (components) =>
            components.forEach((item) => {
              item.get('custom-type') === type && result.push(item);
              find(item.components());
            });
          find(this.components());
          return result;
        },

        async handleParentCollectionChange() {
          let parentSelectedCollection = this.get('parentSelectedCollection');
          if (!parentSelectedCollection && pageCollection) {
            const selectedPageCollection = collections.find(
              (collection) => collection.collectionName === pageCollection.collectionId,
            );
            if (selectedPageCollection) parentSelectedCollection = selectedPageCollection;
          }
          if (parentSelectedCollection) {
            const multiReferenceFields = parentSelectedCollection.fields.filter(
              (field) => FieldTypes.reference.id === field.type,
            );
            let options =
              multiReferenceFields.map((field) => {
                return { value: field.fieldName, name: field.fieldTitle.en };
              }) || [];
            const multiReferenceTraits = this.get('traits').where({
              name: 'multiReferenceField',
            })[0];
            multiReferenceTraits.set('options', options);
          }
        },
        async handleCollectionNameChange() {
          let multiReferenceField = this.get('multiReferenceField');
          let parentSelectedCollection = this.get('parentSelectedCollection');
          if (!parentSelectedCollection && pageCollection) {
            const selectedPageCollection = collections.find(
              (collection) => collection.collectionName === pageCollection.collectionId,
            );
            if (selectedPageCollection) parentSelectedCollection = selectedPageCollection;
          }
          if (multiReferenceField) {
            const selectedRefField = parentSelectedCollection.fields.find(
              (field) => field.fieldName === multiReferenceField,
            );
            const { refCollection, fieldName } = selectedRefField;
            this.setAttributes({
              'data-ref-field': fieldName || '',
              'data-ref-collection': refCollection ? refCollection.collectionName : '',
            });
            // multiReferenceCollectionName = multiReferenceCollectionName ? JSON.parse(multiReferenceCollectionName) : {};
            if (refCollection) {
              const collectionResponse = await getCollectionFields(
                refCollection.collectionName,
                collections,
              );
              this.set('selectedCollectionData', collectionResponse);
              this.set('selectedCollectionStr', `'${JSON.stringify(collectionResponse)}'`);

              const textTraitTargets = this.findCustomType('text');
              const imageTraitTargets = this.findCustomType('image');
              const hrefTraitTargets = this.findType('link');
              const progressBarTraitTargets = this.findType('progress');
              const dataGroupMapTraitTargets = this.findType('data-group-map');

              const textTraitsOptions = await fieldTraitTextContentOptions(
                collectionResponse,
                collections,
              );
              const numberFieldTraitsOptions = fieldTraitProgressBarOptions(collectionResponse);
              if (textTraitTargets.length > 0) {
                textTraitTargets.forEach((component) => {
                  component.set('selectedCollection', collectionResponse);
                });
              }

              if (imageTraitTargets.length > 0) {
                imageTraitTargets.forEach((component) => {
                  component.set('selectedCollection', collectionResponse);
                });
              }
              if (hrefTraitTargets.length > 0) {
                hrefTraitTargets.forEach((component) => {
                  component.set('selectedCollection hrefTraitTargets', collectionResponse);
                });
              }
              if (progressBarTraitTargets.length > 0) {
                progressBarTraitTargets.forEach((component) => {
                  component.removeTrait('data-progress-now');
                  component.removeTrait('data-progress-min');
                  component.removeTrait('data-progress-max');
                  component.addTrait({
                    name: 'data-progress-now',
                    label: false,
                    options: numberFieldTraitsOptions,
                    title: `Get Now From ${collectionResponse.collectionTitle}`,
                    type: 'data-progress-now',
                    changeProp: 1,
                  });
                  component.addTrait({
                    name: 'data-progress-min',
                    label: false,
                    options: numberFieldTraitsOptions,
                    title: `Get Min From ${collectionResponse.collectionTitle}`,
                    type: 'data-progress-min',
                    changeProp: 1,
                  });
                  component.addTrait({
                    name: 'data-progress-max',
                    label: false,
                    options: numberFieldTraitsOptions,
                    title: `Get Max From ${collectionResponse.collectionTitle}`,
                    type: 'data-progress-max',
                    changeProp: 1,
                  });
                });
              }
              if (dataGroupMapTraitTargets.length > 0) {
                dataGroupMapTraitTargets.forEach((component) => {
                  component.removeTrait('data-group-map-lat');
                  component.removeTrait('data-group-map-long');
                  component.removeTrait('data-group-map-header');
                  component.removeTrait('data-group-map-description');

                  component.addTrait({
                    name: 'data-group-map-lat',
                    label: 'Latitude',
                    options: numberFieldTraitsOptions,
                    title: `latitude`,
                    type: 'data-map-trait',
                  });
                  component.addTrait({
                    name: 'data-group-map-long',
                    label: 'Longitude',
                    options: numberFieldTraitsOptions,
                    title: `longitude`,
                    type: 'data-map-trait',
                  });
                  component.addTrait({
                    name: 'data-group-map-header',
                    label: 'Header',
                    options: textTraitsOptions,
                    title: `header`,
                    type: 'data-map-trait',
                  });
                  component.addTrait({
                    name: 'data-group-map-description',
                    label: 'Description',
                    options: textTraitsOptions,
                    title: `description`,
                    type: 'data-map-trait',
                  });
                });
              }
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'child-data-group') {
            return {
              type: 'child-data-group',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });

  domc.addType(pfxFile, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: `:not([data-gjs-type=${pfxFile}])`,
          draggable: `:not([data-gjs-type=${pfxFile}])`,
          'custom-name': opts.labelFileDatagroup,
          icon: '<i class="wb webconnect-list-task"></i>',
          projectId: projectId,
          traits: [
            ...domc.getType('table').model.prototype.defaults.traits,
            {
              type: 'select',
              label: 'Image/File Field',
              name: 'fileImageField',
              changeProp: 1,
              options: [],
            },
          ],
        },

        init() {
          const collection = this.findCollectionFromDataGroup();
          this.set('parentSelectedCollection', collection);
          this.handleParentCollectionChange();
          this.handleCollectionNameChange();
          this.on('change:parentSelectedCollection', this.handleParentCollectionChange);
          this.on('change:fileImageField', this.handleCollectionNameChange);
        },
        findCollectionFromDataGroup() {
          const dataGroup = this.closestType('data-group');
          if (dataGroup) {
            return dataGroup.get('selectedCollectionData') || {};
          }
        },

        findCustomType(type) {
          const result = [];
          const find = (components) =>
            components.forEach((item) => {
              item.get('custom-type') === type && result.push(item);
              find(item.components());
            });
          find(this.components());
          return result;
        },

        async handleParentCollectionChange() {
          let parentSelectedCollection = this.get('parentSelectedCollection');
          console.log('parentSelectedCollectionparentSelectedCollection', parentSelectedCollection);

          if (!parentSelectedCollection && pageCollection) {
            const selectedPageCollection = collections.find(
              (collection) => collection.collectionName === pageCollection.collectionId,
            );
            if (selectedPageCollection) parentSelectedCollection = selectedPageCollection;
          }

          if (parentSelectedCollection) {
            const fileImageFields = parentSelectedCollection.fields.filter((field) =>
              ImageUrlFields.includes(field.type),
            );
            let options =
              fileImageFields.map((field) => {
                return { value: field.fieldName, name: field.fieldTitle.en };
              }) || [];
            const multiFileTraits = this.get('traits').where({
              name: 'fileImageField',
            })[0];
            multiFileTraits.set('options', options);
          }
        },
        async handleCollectionNameChange() {
          let fileImageField = this.get('fileImageField');
          let parentSelectedCollection = this.get('parentSelectedCollection');

          if (!parentSelectedCollection && pageCollection) {
            const selectedPageCollection = collections.find(
              (collection) => collection.collectionName === pageCollection.collectionId,
            );
            if (selectedPageCollection) parentSelectedCollection = selectedPageCollection;
          }

          if (fileImageField) {
            const selectedCollectionField = parentSelectedCollection.fields.find(
              (field) => field.fieldName === fileImageField,
            );
            const { fieldName, validation } = selectedCollectionField;
            const { allowedFileTypes } = validation;
            const isImage = this.hasImage(allowedFileTypes);
            const isFile = this.hasFile(allowedFileTypes);

            const fieldType = isImage ? 'image' : isFile ? 'file' : '';
            const attrs = this.getAttributes();
            attrs['data-file-field'] = fieldName || '';
            attrs['data-field-type'] = fieldType || '';
            attrs['data-js'] = pfxFile;
            this.setAttributes(attrs);

            if (isImage) {
              const imageComponents = this.findCustomType('image');
              if (!imageComponents.length) {
                this.components(
                  `<div data-gjs-type="column" class="col">
                    <img data-gjs-type="bs-image" data-img-src="${
                      fieldName || ''
                    }" src="https://drapcode-static.s3.amazonaws.com/default.png" class="img-fluid">
                  </div>
                  `,
                );
              }
            }
            if (isFile) {
              if (!this.components().length) {
                this.components(`
                <div data-gjs-type="column" class="col">
                  <a data-gjs-type="link-box" draggable="true" data-highlightable="1" class="link-box" data-file-src="${
                    fieldName || ''
                  }" style="display: inline-block">
                  <i data-gjs-type="drapcode-icons" draggable="true" data-highlightable="1" data-js="drapcode-icons" class="drapcode-icons" style="display: inline-block"><svg data-gjs-type="svg" draggable="false" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-gjs="drapcode-icons-svg" class="feather feather-file-text"><path data-gjs-type="svg-in" draggable="true" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z">
                  </path><polyline data-gjs-type="svg-in" draggable="true" points="14 2 14 8 20 8" id="irryn">
                  </polyline><line data-gjs-type="svg-in" draggable="true" x1="16" y1="13" x2="8" y2="13">
                  </line><line data-gjs-type="svg-in" draggable="true" x1="16" y1="17" x2="8" y2="17">
                  </line><polyline data-gjs-type="svg-in" draggable="true" points="10 9 9 9 8 9">
                  </polyline></svg></i>
                  </a>
                </div>
                `);
              }
            }
          }
        },
        hasImage(fileTypes) {
          let hasImage = false;
          for (let i = 0; i < fileTypes.length; i++) {
            if (['png', 'jpeg', 'jpg', 'heic', 'webp'].includes(fileTypes[i])) {
              hasImage = fileTypes[i];
            }
          }
          return !!hasImage;
        },
        hasFile(fileTypes) {
          let hasFile = false;
          for (let i = 0; i < fileTypes.length; i++) {
            if (
              ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt', 'rtf', 'pptx', 'ppt'].includes(
                fileTypes[i],
              )
            ) {
              hasFile = fileTypes[i];
            }
          }
          return !!hasFile;
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === pfxFile) {
            return {
              type: pfxFile,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });
}
